import{a as o}from"./chunk-XSLROD2M.js";import{m as a}from"./chunk-HBP5N4FR.js";a();var s=t=>t.toasts,i=o(s,t=>t.customToasts),l=o(s,t=>t.transactionToasts),S=o(s,t=>t.failTransactionToast);export{s as a,i as b,l as c,S as d};
//# sourceMappingURL=chunk-EK3WHU7G.js.map
